import * as React from 'react';
import { StudyModelLayout } from '../../../StudyModelLayout/StudyModelLayout';
import { SubjectCardWithOverlay } from '../../../SubjectCardWithOverlay/SubjectCardWithOverlay';
import type { SubjectOverlayActionTranslations } from '../../../SubjectOverlayAction/SubjectOverlayAction';
import type { SubjectOverlayContentMessages } from '../../../SubjectOverlayContent/SubjectOverlayContent';
import type { AvailableYearProps, ExtendedSubjectProps } from '../../StudyModelGrid';
import type { SubjectBaseTranslations } from '~/Features/StudyPage/Common/Interfaces/SubjectBaseProps';

export interface StudyModelGridSemestersTranslations extends SubjectBaseTranslations, SubjectOverlayActionTranslations {
    openSubjectOverlay: string;
    closeOverlay: string;
    noSubjectsMessage: string;
}

export interface StudyModelGridSemestersProps {
    selectedYearProps: AvailableYearProps;
    currentYearSubjects: ExtendedSubjectProps[];
    getSubjectInfoUrl: string;
    overlayContentMessages: SubjectOverlayContentMessages;
    translations: StudyModelGridSemestersTranslations;
    className: string;
}

export const StudyModelGridSemesters: React.FC<StudyModelGridSemestersProps> = props => {
    const {
        selectedYearProps,
        currentYearSubjects,
        getSubjectInfoUrl,
        overlayContentMessages,
        className,
        translations,
    } = props;
    const { openSubjectOverlay, closeOverlay, noSubjectsMessage, ...restTranslations } = translations;

    return (
        <div className={className}>
            <StudyModelLayout
                firstHeading={selectedYearProps.firstHeading}
                secondHeading={selectedYearProps.secondHeading}
                subjects={currentYearSubjects}
                noSubjectsMessage={noSubjectsMessage}
                renderSubject={subject => (
                    <SubjectCardWithOverlay
                        subjectOverlayLabel={openSubjectOverlay}
                        closeOverlayLabel={closeOverlay}
                        subjectName={subject.name}
                        subjectCode={subject.code}
                        subjectCategory={subject.category}
                        points={subject.points}
                        translations={restTranslations}
                        subjectDescription={subject.description}
                        isDescriptionOutdated={subject.isDescriptionOutdated}
                        messages={overlayContentMessages}
                        fetchSubjectLinkUrl={getSubjectInfoUrl}
                    />
                )}
            />
        </div>
    );
};
